<template>
  <div id="adg_restaurante">
    <div class="portada-portafolio">
      <div class="subportada-portafolio d-flex align-items-center justify-content-center flex-wrap">
        <div>
          <h1>ADG Salud</h1>
        </div>
      </div>
    </div>
    <div class="contenido">
      <div class="py-5 row w-100 mx-auto">
        <div class="contenedor-texto col-12 pb-4 mb-1">
          <div>
            <titulo-seccion>Gestiona tu centro de salud con nuestras soluciones</titulo-seccion>
            <p class="pt-3">ADG Salud optimiza todos los procesos de los centro de salud.</p>
          </div>
        </div>

        <!-- ------------------ Caracteristicas ------------------ -->
        <div class="col-12">
          <div class="row w-100 mx-auto justify-content-center pb-3">
            <div class="col-12">
              <titulo-seccion class="pb-2">Obtén beneficios</titulo-seccion>
              <p>Adquiere esta solución y disfruta de increíbles ventajas.</p>
            </div>
            <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-2">
              <div class="contenedor-icono">
                <i class="fas fa-sort"></i>
              </div>
              <h3 class="mt-3 mb-1">Orden</h3>
              <p>Organiza todos tus procesos.</p>
            </div>

            <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-2">
              <div class="contenedor-icono">
                <i class="fas fa-clock"></i>
              </div>
              <h3 class="mt-3 mb-1">Tiempo</h3>
              <p>Optimiza el tiempo de todos los procesos.</p>
            </div>

            <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-2">
              <div class="contenedor-icono">
                <i class="fas fa-users"></i>
              </div>
              <h3 class="mt-3 mb-1">Clientes</h3>
              <p>Contenta a tus clientes simplificando sus procesos.</p>
            </div>
          </div>
        </div>
        <!-- ------------------ Caracteristicas ------------------ -->

        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/salud/consultas.jpeg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <h2>Reserva de consultas</h2>
            <p>Gestiona y optimiza los procesos de reservas.</p>
          </div>
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <h2>Gestión de cuidado</h2>
            <p>Administración de datos referentes los pacientes.</p>
          </div>
        </div>
        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/salud/cuidado.jpeg"
            width="100%"
            height="100%"
          />
        </div>

        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/salud/clientes.jpeg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <div>
              <h2>Fideliza clientes</h2>
              <p>Haz los clientes se vuelvan fieles a tu centro de salud con nuestro sistema de fidelización.</p>
            </div>
          </div>
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <div>
              <h2>Administra el almacén</h2>
              <p>Controle la existencia, precios, costos y más, de los productos para optimizar su almacén.</p>
            </div>
          </div>
        </div>

        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/salud/almacen.jpeg"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
#adg_restaurante {
  min-height: 100vh;
}
.portada-portafolio {
  height: 50vh;
  width: 100%;
  color: white;
  background: #262626;
  background: url("../../../assets/images/productos/domit/salud.jpeg");
  background-size: cover;
}
.portada-portafolio h1 {
  font-size: calc(3.5em + 1vh);
  letter-spacing: -0.5px;
}
.portada-portafolio h2 {
  font-size: 2em;
}
.portada-portafolio h2,
h1 {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
.subportada-portafolio {
  background: rgba(0, 0, 0, 0.35);
  height: 100%;
  width: 100%;
}
.contenido {
  padding: 0 6%;
}
.contenedor-texto {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.contenedor-icono {
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15);
  width: 100px;
  margin: auto;
  height: 100px;
  border-radius: 200px;
  color: #262626;
  border: 6px solid #262626;
  font-size: 3.1em;
  display: flex;
  align-items: center;
  justify-content: center;
}
p {
  padding-top: 15px;
  color: #595959;
  font-size: calc(0.9em + 0.3vw);
}

@media screen and (max-width: 768px) {
  p {
    font-size: calc(1em + 0.3vw);
  }
}
</style>